module.exports = __webpack_public_path__ + "static/media/JAGScreen.e0a26f77.png";